import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import HeroAbout from "../components/HeroAbout";
import Brands from "../components/Brands";
import AboutRungdo from "../components/AboutRungdo";
import Footer from "../components/Footer";

const AboutusPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div className="aboutus-page">
      <Navbar />
      <HeroAbout />
      <Brands />
      <AboutRungdo />
      <Footer />
    </div>
  );
};

export default AboutusPage;
